import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTriangleExclamation } from "@fortawesome/pro-light-svg-icons"; 

@Component({
  selector: 'chip-error',
  standalone: true,
  imports: [CommonModule,FontAwesomeModule],
  templateUrl: './chip-error.component.html',
  styleUrl: './chip-error.component.scss'
})
export class ChipErrorComponent {
  @Input() text: string = 'Debes diligenciar todos los campos en rojo';
  @Input() typeText: string = ''
  iconExcla = faTriangleExclamation;
}
